export class PaymentModeConstants {
    public static Money_Order = 'Money_Order';
    public static Wire_Transfer = 'Wire_Transfer';
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/payment-mode.constants.ts